<template>
  <div class="reports">
    <ReportListsWinloseComponent
      :ref-key-text="refKeyText"
      :title="title"
      :url-path="urlPath"
      :route-name="routeName"
    />
  </div>
</template>

<script>
import ReportListsWinloseComponent from '@/components/ReportListsWinloseComponent-v1.vue'

export default {
  components: {
    ReportListsWinloseComponent,
  },
  data() {
    return {
      refKeyText: 'Member',
      title: 'W/L Member (Simple)',
      urlPath: '/reports/member_winlose_lists',
      routeName: 'reports-member-winlose-lists',
    }
  },
}
</script>

<style>

</style>
